"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = callWithCallback;

var _typeofOrNull = _interopRequireDefault(require("../misc/typeofOrNull"));

var _callWithPromise = _interopRequireDefault(require("./callWithPromise"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

var functionName = 'callWithCallback';

function callWithCallback(client, callee) {
  if (typeof callee !== 'function') {
    throw new Error("\n        ".concat(functionName, " expected a function as its callee (second argument) but receieved\n        an argument of type ").concat((0, _typeofOrNull["default"])(callee), ". Check\n        that you are passing a valid callee into the call method.\n      "));
  }

  for (var _len = arguments.length, args = new Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
    args[_key - 2] = arguments[_key];
  }

  if (args.length < 1) {
    throw new Error("\n        ".concat(functionName, " expected a callback argument in addition to context and\n        callee but did not receive one.\n      "));
  }

  var callback = args[args.length - 1];
  var calleeArgs = args.slice(0, args.length - 1);

  if (typeof callback !== 'function') {
    throw new Error("\n        ".concat(functionName, " expected a function as the last argument but receieved\n        an argument of type ").concat((0, _typeofOrNull["default"])(callback), ".\n      "));
  }

  var failureHandler = function failureHandler(err) {
    // $FlowFixMe - handled manually
    return callback(err, undefined);
  };

  var successHandler = function successHandler(result) {
    // $FlowFixMe - handled manually
    return callback(null, result);
  };

  _callWithPromise["default"].apply(void 0, [client, callee].concat(_toConsumableArray(calleeArgs)))["catch"](failureHandler).then(successHandler);
}